import { gql } from '@apollo/client'

export const GET_DISK_LIST = gql`
  query getDiskList($offset: Int, $first: Int, $param: NetworkDiskParam) {
    networkDiskQuery {
      list(page: { offset: $offset, first: $first }, param: $param) {
        edges {
          node {
            isFile: file
            name: fileName
            size: fileSize
            time: modifyTime
            path
          }
        }
        pageInfo {
          totalCount
        }
      }
    }
  }
`

export const GET_DISK_STROAGE = gql`
  query getDiskStroage {
    networkDiskQuery {
      space {
        usage
        maximum
      }
    }
  }
`

export const CREATE_DISK_FOLDER = gql`
  mutation createDiskFolder($param: NetworkDiskCreateFolderInput) {
    networkDiskMutation {
      status: createFolder(input: $param)
    }
  }
`

export const RENAME_DISK_FOLDER = gql`
  mutation renameDiskFolder($param: NetworkDiskRenameInput) {
    networkDiskMutation {
      status: rename(input: $param)
    }
  }
`

export const DELETE_DISK_FOLDER = gql`
  mutation deleteDiskFolder($param: NetworkDiskDelInput) {
    networkDiskMutation {
      status: del(input: $param)
    }
  }
`

export const MOVE_DISK_FOLDER = gql`
  mutation moveDiskFolder($param: NetworkDiskMoveInput) {
    networkDiskMutation {
      status: move(input: $param)
    }
  }
`
